<template>
  <div>

    <swatches v-model="col" colors="text-advanced" row-length="10" popover-to="left">
        <div v-bind:id="id" slot="trigger" v-bind:style="{background: col}" class="hit-form-control" ></div>
   </swatches>

  </div>
</template>

<script>
import Swatches from 'vue-swatches'

export default{

  components: {Swatches},
  props: {
    id: String,
    color: String,
    callback: Function
  },
  data: function () {
    return {

      col: this.color
    }
  },

  watch: {
    col: function (val) { if (typeof this.callback === 'function') { this.callback(val) } }
  }

}
</script>
